import { render, staticRenderFns } from "./liveblogComposer.vue?vue&type=template&id=21ec99c5&scoped=true&"
import script from "./liveblogComposer.vue?vue&type=script&lang=js&"
export * from "./liveblogComposer.vue?vue&type=script&lang=js&"
import style0 from "./liveblogComposer.vue?vue&type=style&index=0&id=21ec99c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec99c5",
  null
  
)

export default component.exports